import { Component } from '@angular/core';
import { PageResultDealsEvaluation, RequestDeals } from '../interfaces/deals';
import { ServiceInfoClientService } from '../../files-clients/service/service-info-client.service';
import { Deal } from '../../clients/interface/data.interface';

@Component({
  selector: 'app-view-deals-evaluations',
  templateUrl: './view-deals-evaluations.component.html',
  styleUrls: ['./view-deals-evaluations.component.scss']
})
export class ViewDealsEvaluationsComponent {
  public resultPage: PageResultDealsEvaluation;
  public result: Deal[];
  public booleanFlag: boolean = true;
  public estadoResolutivo = "Pendientes";
  public estadoTrato = "Abiertos";
  private intervalo: any;
  public request: RequestDeals = {
    page: 1,
    pageSize: 10,
    sortField: '',
    sortDirection: 'desc',
    start: null,
    end: null
  };

  constructor(private service: ServiceInfoClientService){
    this.request = {
      ...this.request
    };
  }

  ngOnInit(): void {
    this.getDealsEvaluation();
    this.iniciarIntervalo();
  }

  ngOnDestroy(): void {
    this.limpiarIntervalo(); 
  }

  public getDealsEvaluation(): void {
    this.service.getDealsEvaluation(this.request).subscribe({
      next:(response) => {
        this.booleanFlag = false;
        this.resultPage = response;
        this.result = response.result;
      },
      error:(err)=>{console.log(err)}
    });
  }

  public onPagination(event: any) {
    this.booleanFlag = true;
    this.request.page = event.page; 
    this.request.pageSize = event.pageSize; 
    this.getDealsEvaluation();
  }

  public onSorting(event: any) {
    if (event) {
      this.booleanFlag = true;
      this.request.sortField = event.sortColumn; 
      this.request.sortDirection = event.sortDirection; 
      this.getDealsEvaluation();
    }
  }

  public onSearch(event: { search: string, finalidad: string, start: Date, end: Date, estado: string, estadoActiviti: number, nameAccion: string, etiqueta: string }) {
    this.request.search = event?.search?.toString() || '';
    this.request.finalidad = event?.finalidad?.toString() || '';
    this.request.estado = event?.estado?.toString() || '';
    this.request.start = event?.start || null;
    this.request.end = event?.end || null;
    this.request.page = 1; 
    this.request.estadoActiviti = event?.estadoActiviti;
    this.request.estadoAccion = event?.nameAccion;
    this.request.etiqueta = event?.etiqueta;
    this.booleanFlag = true;
    this.getDealsEvaluation();
    if(event?.estadoActiviti==0)
    {
      this.estadoResolutivo = 'Pendientes';
    }
    else if(event?.estadoActiviti==1) {
      this.estadoResolutivo = 'Aprobados';
    }
    else if(event?.estadoActiviti==2) {
      this.estadoResolutivo = 'Rechazados';
    }
    else if(event?.estadoActiviti==3) {
      this.estadoResolutivo = 'Requieren Información';
    }

    if(event?.estado?.toString())
    {
      this.estadoTrato = event?.estado?.toString();
    }
  }

  public iniciarIntervalo(): void {
    this.intervalo = setInterval(() => {
      this.getDealsEvaluation();
    }, 5 * 60 * 1000); // 5 minutos en milisegundos
  }

  public limpiarIntervalo(): void {
    if (this.intervalo) {
      clearInterval(this.intervalo);
    }
  }

}